import 'alva-theme-core';
document.documentElement.setAttribute('data-alva-theme-core', 'ready');

const components = [
  {name: 'gallery', selector: 'product-gallery,product-gallery-navigation,open-lightbox-button,quick-buy-modal'},
  {name: 'variants', selector: 'variant-picker,product-sticky-bar,gift-card-recipient,quick-buy-modal'},
  {name: 'facets', selector: 'facets-form,facets-drawer,facet-link,facets-sort-popover,price-range,collection-banner,collection-layout-switch'},
  {name: 'editorial', selector: 'before-after,blog-posts,dynamic-grid,account-login,faq-toc,image-with-text,image-with-text-overlay,images-with-text-scroll,article-toolbar,media-grid,multi-column,multiple-media-with-text'},
  {name: 'countdown', selector: 'countdown-timer,countdown-timer-flip,countdown-timer-flip-digit'},
  {name: 'quickorder', selector: 'quick-order-list,quick-order-list-quantity-selector,quick-order-list-remove-variant,quick-order-list-remove-all'},
  {name: 'look', selector: 'shop-the-look-mobile-carousel,shop-the-look-product-list-carousel,shop-the-look-desktop-carousel,shop-the-look-popover'},
  {name: 'slides', selector: 'slideshow-carousel,testimonial-carousel,text-with-icons-carousel,timeline-carousel'}
];
let fallback;
const jobs = new Map();
function load(name) {
  if (jobs.has(name)) return jobs.get(name);
  const job = import('alva-theme-' + name).then(module => {
    document.documentElement.setAttribute('data-alva-theme-' + name, 'ready');
    return module;
  }).catch(error => {
    console.error('Alva component load failed:', name, error);
    document.documentElement.setAttribute('data-alva-theme-fallback', name);
    return fallback || (fallback = import('theme'));
  });
  jobs.set(name, job);
  return job;
}
function scan(root) {
  if (!root || root.nodeType !== 1) return;
  const remaining = components.filter(component => !jobs.has(component.name));
  if (!remaining.length) return;
  const selector = remaining.map(component => component.selector).join(',');
  const matches = Array.from(root.querySelectorAll(selector));
  if (root.matches(selector)) matches.unshift(root);
  if (!matches.length) return;
  remaining.forEach(component => {
    if (matches.some(node => node.matches(component.selector))) load(component.name);
  });
}
scan(document.documentElement);
const pending = new Set();
let frame = 0;
const observer = new MutationObserver(records => {
  records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) pending.add(node);
  }));
  if (!pending.size || frame) return;
  frame = requestAnimationFrame(() => {
    frame = 0;
    const roots = Array.from(pending).filter(root => root.isConnected);
    roots.forEach(root => {
      if (!roots.some(parent => parent !== root && parent.contains(root))) scan(root);
    });
    pending.clear();
    if (components.every(component => jobs.has(component.name))) observer.disconnect();
  });
});
observer.observe(document.body, {childList: true, subtree: true});
document.addEventListener('shopify:section:load', event => scan(event.target));
document.addEventListener('alva:pdp:render', () => scan(document.querySelector('.shopify-section--main-product')));
window.addEventListener('pagehide', () => observer.disconnect());
window.addEventListener('pageshow', event => {
  if (!event.persisted) return;
  scan(document.documentElement);
  observer.observe(document.body, {childList: true, subtree: true});
});
